import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-staff-user-accounts',
    templateUrl: './staff-user-accounts.component.html',
    styleUrls: ['./staff-user-accounts.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StaffUserAccountsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
